module.exports = __webpack_public_path__ + "static/media/scottish-pacific.11ad33b1.png";